
import { defineComponent } from 'vue';
import useValidate from '@vuelidate/core';
import { TenantDetailsValidations } from '@/views/new-design/validations/TenantReview';
import moment from 'moment';
import maskUtil from '@/utils/mask';

export default defineComponent({
  props: {
    isCurrent: { default: false },
  },
  emits: ['findExistingTenant', 'submit'],
  data() {
    return {
      v$: useValidate(),
      form: {
        first_name: null,
        last_name: null,
        date_of_birth: null,
        mobile_number: null,
        email: null,
      },
    };
  },
  computed: {
    maskingMobile() {
      return maskUtil.mobile.aus;
    },
  },
  validations() {
    return TenantDetailsValidations;
  },
  watch: {
    form: {
      handler(value) {
        if (value.first_name && value.last_name && value.date_of_birth) {
          this.findExistingTenant();
        }
      },
      deep: true,
    },
  },
  methods: {
    submit() {
      this.v$.$validate(); // checks all inputs

      if (this.v$.$error) {
        return false;
      }

      this.$emit('submit', this.form);
    },
    clear() {
      this.v$.$reset();

      this.form.first_name = null;
      this.form.last_name = null;
      this.form.date_of_birth = null;
      this.form.mobile_number = null;
      this.form.email = null;
    },
    setInitialData(data) {
      this.form.first_name = data.first_name;
      this.form.last_name = data.last_name;
      this.form.date_of_birth = data.date_of_birth;
      this.form.mobile_number = data.mobile_number;
      this.form.email = data.email;
    },
    findExistingTenant() {
      this.$emit('findExistingTenant', {
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        date_of_birth: moment(
          (this.form as any)?.date_of_birth as string,
          'YYYY-MM-DD'
        )
          .format('YYYY-MM-DD')
          .toString(),
      });
    },
  },
});
